// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { externalTestPartnerStatusEnum } from './ExternalTestPartnerStatusEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const externalTestPartnerId = (z.number());
export const externalTestPartner = z.object({
    id: externalTestPartnerId,
    name: z.string(),
    status: externalTestPartnerStatusEnum,
    contact_person: z.string().nullable(),
    email: z.string().nullable(),
    phone_number: z.string().nullable(),
    address: z.string().nullable(),
    website: z.string().nullable(),
    service_description: z.string().nullable(),
    accreditations: z.string().nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    code: z.string(),
});
export const externalTestPartnerInitializer = z.object({
    id: externalTestPartnerId.optional(),
    name: z.string(),
    status: externalTestPartnerStatusEnum.optional(),
    contact_person: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    phone_number: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    service_description: z.string().optional().nullable(),
    accreditations: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    code: z.string(),
});
export const externalTestPartnerMutator = z.object({
    id: externalTestPartnerId.optional(),
    name: z.string().optional(),
    status: externalTestPartnerStatusEnum.optional(),
    contact_person: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    phone_number: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    service_description: z.string().optional().nullable(),
    accreditations: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    code: z.string().optional(),
});
//# sourceMappingURL=ExternalTestPartner.js.map